export default "__VITE_ASSET__Bxmy2yKr__"